var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppointmentsExpired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2,.cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:50px;}.cls-2{stroke-miterlimit:10;}.cls-3{stroke-linejoin:round;}.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expired"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300,
    cy: 300,
    r: 299.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.76,201.8a158,158,0,1,1-20.67,156.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "297.14 225.67 297.14 303.65 362.37 331.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.46,254.22l-17.57-87.65c-3-15.12,14.22-26,26.53-16.7l106.67,80.31c12.31,9.27,6.65,28.85-8.71,30.11l-89.1,7.35A16.77,16.77,0,0,1,118.46,254.22Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentsExpired);
export default __webpack_public_path__ + "static/media/appointments_expired.332628bbcb5aef81dbbc853af93ecd68.svg";
export { ForwardRef as ReactComponent };